(() => {
    if (!Array.isArray(hvacDiffusersObject) || hvacDiffusersObject.length < 2) return;
    const { createApp, reactive } = Vue;

    const multipleHvacsState = reactive({
        hvac_systems: [
            {
                product_id: hvacDiffusersObject[0].data.id,
                variant_id: hvacDiffusersObject[0].data.variants[0].id
            },
            {
                product_id: hvacDiffusersObject[1].data.id,
                variant_id: hvacDiffusersObject[1].data.variants[0].id
            },
        ],
        products: [
            ...hvacDiffusersObject
        ],
    });

    const colorMap = {
        white: "#ffffff",
        black: "#000000"
    }

    const removeHVAC = (hvac) => { 
        const index = multipleHvacsState.hvac_systems.findIndex(item => item === hvac);
        if (index !== -1 && multipleHvacsState.hvac_systems.length > 1) {
            multipleHvacsState.hvac_systems.splice(index, 1);
        }
    };

    const addHVAC = () => {
        multipleHvacsState.hvac_systems.push({ product_id: hvacDiffusersObject[0].data.id, variant_id: hvacDiffusersObject[0].data.variants[0].id });
    };

    const updateHVAC = (index, event) => {
        multipleHvacsState.hvac_systems[index] = { 
            ...multipleHvacsState.hvac_systems[index], 
            product_id: Number(event.target.value) 
        };
    };

    const getProduct = (id) => {
        return multipleHvacsState.products.find(product => product.id === id) || {};
    };

    const getVariant = (product, id) => {
        if (!product || !product.data || !product.data.variants) return {};
        return product.data.variants.find(variant => variant.id === id) || product.data.variants[0] || {};
    };

    const getTotalCompareAtPrice = () => {
        const totalCAP = multipleHvacsState.hvac_systems.reduce((accumulator, item) => {
            const product = getProduct(item.product_id);
            return accumulator + (product.data ? parseFloat(product.data.compare_at_price) : 0);
        }, 0);
        return (totalCAP / 100).toFixed(2);
    };

    const getTotalPrice = () => {
        const totalPrice = multipleHvacsState.hvac_systems.reduce((accumulator, item) => {
            const product = getProduct(item.product_id);
            return accumulator + (product.data ? parseFloat(product.data.price) : 0);
        }, 0);
        return (totalPrice / 100).toFixed(2);
    };

    const addToCart = () => {
        let formData = {
            'items': multipleHvacsState.hvac_systems
                .map(hvac => {
                    const product = getProduct(hvac.product_id);
                    const variant = getVariant(product, hvac.variant_id);
                    return variant.id ? { 'id': variant.id, 'quantity': 1 } : null;
                })
                .filter(item => item !== null)
        };

        if (formData.items.length === 0) {
            console.error("No valid items to add to cart.");
            return;
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .catch(error => console.error('Error:', error));
    }

    const multipleHvacsApp = createApp({
        name: "multipleHvacsApp",
        setup() {
            return {
                multipleHvacsState,
                colorMap,
                removeHVAC,
                addHVAC,
                getProduct,
                getVariant,
                updateHVAC,
                getTotalCompareAtPrice,
                getTotalPrice,
                addToCart,
            };
        },
        delimiters: ["${", "}"],
    });

    multipleHvacsApp.mount("#multipleHvacsApp");
})();